import { faCoin, faCoins } from '@fortawesome/pro-duotone-svg-icons'
import { Stack } from '@mui/material'
import { memo } from 'react'

import Popup from 'src/components/shared/popup/Popup'
import DisplayValue from 'src/components/shared/text/DisplayValue'
import Text from 'src/components/shared/text/Text'
import { formatQBXCurrency } from 'src/util/staking/staking.helpers'

const ConfirmStakingPopup = ({
  title,
  desc,
  valueDesc,
  onSubmit,
  onCancel,
  t,
  value,
  submitLabel,
  hideHelpText = true,
  loading,
  error,
  disableClose,
  stakingValue
}) => {
  return (
    <Popup
      title={t(title)}
      description={t(desc)}
      submitLabel={t(submitLabel || 'common.confirm')}
      onFormSubmit={onSubmit}
      onCancel={onCancel && onCancel}
      cancelLabel={t('common.cancel')}
      submitBtnProps={{ loading }}
      icon={stakingValue ? faCoin : faCoins}
      disableClose={disableClose}
    >
      <Stack spacing={1} sx={{ py: { xs: 1, md: 1 } }}>
        <DisplayValue title={formatQBXCurrency(value)} desc={valueDesc} />
        {stakingValue && (
          <Text
            label={t('brand:staking.the-other-option', { value: stakingValue })}
          />
        )}
        {!hideHelpText && (
          <Text label={t('brand:staking.to-increase-your-level')} />
        )}
        {error && <Text label={t(error)} color='error' />}
      </Stack>
    </Popup>
  )
}

export default memo(ConfirmStakingPopup)
